import type { ImageFormat } from '@liks/backend-svc-api/esm/models/index';
import type { ImageAspectRatio } from './gallery';

export type ChatMessageAiAuthor = {
  type: 'ai';
  name: string;
};

export type ChatMessageUserAuthor = {
  type: 'user';
  id: string;
  name: string;
};

export type ChatMessageAuthor = ChatMessageAiAuthor | ChatMessageUserAuthor;

/** Citation attached to an assistant reply (`PlatformMessage.sources`). */
export type ChatMessageSourceType =
  'KDB_DOCUMENT' | 'CRAWL' | 'INTERNET' | 'TRAINING_EXAMPLE';

export type ChatMessageSourceRefStatus =
  'ACTIVE' | 'DOCUMENT_DELETED' | 'KDB_DELETED' | 'TRAINING_EXAMPLE_DELETED';

export type ChatMessageSource = {
  id?: string;
  documentId?: string;
  documentName?: string;
  knowledgeBaseId?: string;
  knowledgeBaseName?: string;
  sourceType?: ChatMessageSourceType | string;
  sourceUrl?: string;
  sourceTitle?: string;
  trainingExampleId?: string;
  refStatus?: ChatMessageSourceRefStatus | string;
};

export type ChatMessage = {
  id: string;
  sessionId: string;
  content: string;
  sentAt: string;
  author: ChatMessageAuthor;
  sources?: ChatMessageSource[];
  /** True when the backend reports this message has attachments to fetch. */
  hasAttachment?: boolean;
  isPendingAssistantReply?: boolean;
  isStreamingAssistantReply?: boolean;
  imageGenerationFailed?: boolean;
  imageFormat?: ImageFormat;
  imageAspectRatio?: ImageAspectRatio;
};

export function isAiMessage(
  message: ChatMessage,
): message is ChatMessage & { author: ChatMessageAiAuthor } {
  return message.author.type === 'ai';
}

export function isUserMessage(
  message: ChatMessage,
): message is ChatMessage & { author: ChatMessageUserAuthor } {
  return message.author.type === 'user';
}
